// @flow
import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { setOrganizationsFilter } from 'domain/organization';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';

import bg from './images/bg.png';

const NotFound = () => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const onClick = () => {
    dispatch(setOrganizationsFilter(''));
  };
  return (
    <>
      <Divider sx={{ my: 1, mb: 5 }} />
      <Box textAlign="center" mx="auto">
        <img src={bg} alt="not-found" />
        <Typography variant="h5" mt={2}>
          {formatMessage({
            id: 'organizations.notFound.title',
            defaultMessage: 'No results have been found',
          })}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {formatMessage({
            id: 'organizations.notFound.body',
            defaultMessage: "We can't find any organizations matching your search. Please, try a different search.",
          })}
        </Typography>
        <Button sx={{ marginTop: 3 }} onClick={onClick}>
          {formatMessage({
            id: 'companies.notFound.btn',
            defaultMessage: 'Reset search',
          })}
        </Button>
      </Box>
    </>
  );
};

export default NotFound;
